import { IComponentOptions } from 'angular';
import { FindACourseTableCtrl } from './find-a-course-table.controller';

export const FindACourseTableComponent: IComponentOptions = {
  template: require('./find-a-course-table.html'),
  bindings: {
    termYear: '<',
    studentCourseDiffs: '<',
    studentGapPlans: '<',
    schoolCourseDiffs: '<',
    schoolGapPlans: '<',
    student: '<',
    school: '<',
    termType: '<',
    initialFilter: '<',
  },
  controller: FindACourseTableCtrl,
};
